import { gql, useQuery } from '@apollo/client';
import { AnyObject } from '../../../models/types';

export interface GetClusterHealthSummaryVars {
    domainIdentifier: String;
}

const GET_CLUSTER_HEALTH_SUMMARY = gql`
    query GetClusterHealthSummary(
            $domainIdentifier: String
        ){
        clusterHealth: clusterHealth(
            domainIdentifier: $domainIdentifier
        )
        nodes: numberOfNodes(
            domainIdentifier: $domainIdentifier
        )
        clusterStats: clusterStats(
            domainIdentifier: $domainIdentifier
        )
    }
`;

export const useClusterHealthSummaryQuery = (vars: GetClusterHealthSummaryVars) => {
    return useQuery<AnyObject, GetClusterHealthSummaryVars>(GET_CLUSTER_HEALTH_SUMMARY, {
        variables: { ...vars },
        errorPolicy: 'all',
        fetchPolicy: 'network-only'
    });
};